(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6185],{

/***/ 19739:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/telemedicine/doctors",
      function () {
        return __webpack_require__(87968);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89961);
/* harmony import */ var _components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22522);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31591);
/* harmony import */ var _styles_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64952);
/* harmony import */ var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78287);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  color: ",
        ";\n  visibility: ",
        ";\n  position: ",
        ";\n  display: flex;\n\n  @media screen and (max-width: ",
        ") {\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  svg {\n    margin: 0 2px;\n  }\n  p:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 24px 24px 0;\n  position: relative;\n  z-index: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CustomBreadCrumbs = function(param) {
    var visible = param.visible, breadCrumbs = param.breadCrumbs;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var onClickBreadCrumb = function(name) {
        (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .logger */ .kg)({
            pageName: (0,_utils_logger__WEBPACK_IMPORTED_MODULE_7__/* .getPageName */ .j0)(router),
            eventName: "breadcrumb_".concat(name, "_click")
        });
    };
    var breadCrumbsWithHome = [
        {
            label: "홈",
            url: "/",
            logName: "home"
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(breadCrumbs));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        visible: visible,
        id: "breadcrumbs",
        children: breadCrumbsWithHome.map(function(item, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Path, {
                role: "button",
                onClick: function() {
                    return onClickBreadCrumb(item.logName);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: item.url,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: item.label
                            })
                        })
                    }),
                    index !== breadCrumbsWithHome.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_atom_icon_Arrow_BreadCrumbArrow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            }, item.label);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomBreadCrumbs);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.typography.UI13M;
}, function(param) {
    var theme = param.theme;
    return theme.color.gray400;
}, function(param) {
    var visible = param.visible;
    return visible ? "visible" : "hidden";
}, function(param) {
    var visible = param.visible;
    return visible ? "static" : "absolute";
}, _styles_layout__WEBPACK_IMPORTED_MODULE_10__/* .Tablet */ .YD, function(param) {
    var theme = param.theme;
    return theme.typography.UI14R;
});
var Path = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-1"
})(_templateObject1());
var BreadCrumbsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-aed661fe-2"
})(_templateObject2(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_6__/* .zIndex.BreadCrumb */ .W.BreadCrumb);
CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;


/***/ }),

/***/ 75275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);
/* harmony import */ var _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31591);
/* harmony import */ var _types_app__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9912);
/* harmony import */ var _types_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37072);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  & > * {\n    &:first-child {\n    }\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: ",
        ";\n  z-index: 200;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  width: 100%;\n  top: 0;\n\n  ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          top: ",
        "px;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          top: 0px;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-direction: column;\n  width: 100%;\n  z-index: ",
        ";\n  position: sticky;\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  z-index: ",
        ";\n  position: sticky;\n  bottom: 0;\n  padding: 32px 20px 20px;\n  background-color: ",
        ";\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 1) 30%,\n    rgba(255, 255, 255, 1) 100%\n  );\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3b0b8d64-0"
})(_templateObject());
var TemplateHeader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-3b0b8d64-1"
})(_templateObject1(), function(param) {
    var position = param.position;
    return position ? position : "sticky";
}, function(param) {
    var theme = param.theme, useSafeArea = param.useSafeArea;
    return "\n      background-color: ".concat(theme.color.white, ";\n      border: 0px solid ").concat(useSafeArea ? "red" : "green", ";\n  ");
}, function(param) {
    var theme = param.theme, useSafeArea = param.useSafeArea, height = param.height;
    var _client = theme.client, clientType = _client.clientType, isAndroid = _client.isAndroid;
    var headerHeight = height !== null && height !== void 0 ? height : 60;
    switch(clientType){
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEBVIEW */ .B.MOBILE_WEBVIEW:
            if (isAndroid) {
                return "\n            height: ".concat(headerHeight, "px;\n          ");
            }
            return "\n          height: ".concat(useSafeArea ? headerHeight : 100, "px;\n        ");
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.WEB */ .B.WEB:
            return "\n          height: ".concat(headerHeight, "px;\n        ");
        case _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEB */ .B.MOBILE_WEB:
            return "\n          height: ".concat(headerHeight, "px;\n          top: 60px;\n        ");
        default:
            return "\n            height: ".concat(0, "px;\n          ");
    }
});
var StickyTemplateHeader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-3b0b8d64-2"
})(_templateObject4(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.AppHeader */ .W.AppHeader, function(param) {
    var type = param.type, theme = param.theme;
    switch(type){
        case _types_header__WEBPACK_IMPORTED_MODULE_4__/* .HeaderType.WithMobileHeader */ .n.WithMobileHeader:
            {
                return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject2(), [
                    _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.WEB */ .B.WEB,
                    _types_app__WEBPACK_IMPORTED_MODULE_3__/* .ClientType.MOBILE_WEBVIEW */ .B.MOBILE_WEBVIEW
                ].includes(theme.client.clientType) ? 0 : 60);
            }
        default:
            return (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject3());
    }
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3b0b8d64-3"
})(_templateObject5());
var StickyBottom = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    componentId: "sc-3b0b8d64-4"
})(_templateObject6(), _constants_zIndex__WEBPACK_IMPORTED_MODULE_2__/* .zIndex.BottomSticky */ .W.BottomSticky, function(param) {
    var theme = param.theme;
    return theme.color.white;
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
var TemplateLayout = function() {};
var Header = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TemplateHeader, {
        useSafeArea: props.useSafeArea,
        position: props.position,
        height: props.height,
        children: props.children
    });
};
var StickyHeader = function(param) {
    var children = param.children, type = param.type, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyTemplateHeader, {
        type: type,
        style: style,
        children: children
    });
};
TemplateLayout.Wrapper = Wrapper;
/**
 * @deprecated 확장성을 위해 이관예정
 */ TemplateLayout.Header = Header;
TemplateLayout.StickyHeader = StickyHeader;
TemplateLayout.Content = Content;
TemplateLayout.StickyBottom = StickyBottom;
/* harmony default export */ __webpack_exports__["Z"] = (TemplateLayout);


/***/ }),

/***/ 4380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ EPixelEventName; }
/* harmony export */ });
var EPixelEventName;
(function(EPixelEventName) {
    EPixelEventName["PageIn"] = "page_in";
    EPixelEventName["BottomCtaClick"] = "bottom_cta_click";
    EPixelEventName["TopCtaClick"] = "top_cta_click";
    EPixelEventName["SelectPharmacy"] = "select_pharmacy";
})(EPixelEventName || (EPixelEventName = {}));


/***/ }),

/***/ 76122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lE": function() { return /* binding */ useGetDiagnosisCategoriesV2Query; },
/* harmony export */   "ze": function() { return /* binding */ useSearchDoctorsByUserQuery; }
/* harmony export */ });
/* unused harmony exports SearchDoctorsByUserDocument, GetDiagnosisCategoriesV2Document */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36492);
/* harmony import */ var _utils_fetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8391);


var SearchDoctorsByUserDocument = "\n    query SearchDoctorsByUser($request: DoctorSearchByUserRequestInput!) {\n  searchDoctorsByUser(request: $request) {\n    totalCount\n    items {\n      createdAt\n      hospitalName\n      id\n      publicId\n      isAffiliated\n      medicineType\n      name\n      profileUrl\n      medicineType\n      professionalDepartment {\n        name\n      }\n      readyForVideoCall\n      reviewAverageRating\n      reviewCount\n      bookingInfo {\n        bookingAvailability\n        isBookable\n        todayBookable\n        todayCutoffTime\n        todayKickoffTime\n        todaySchedule\n        tomorrowBookable\n        tomorrowCutoffTime\n        tomorrowKickoffTime\n        tomorrowSchedule\n      }\n    }\n  }\n}\n    ";
var useSearchDoctorsByUserQuery = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "SearchDoctorsByUser",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables), options);
};
useSearchDoctorsByUserQuery.getKey = function(variables) {
    return [
        "SearchDoctorsByUser",
        variables
    ];
};
useSearchDoctorsByUserQuery.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(SearchDoctorsByUserDocument, "SearchDoctorsByUser", variables, options);
};
var GetDiagnosisCategoriesV2Document = "\n    query GetDiagnosisCategoriesV2($contactType: DiagnosisContactType!) {\n  getDiagnosisCategoriesV2(contactType: $contactType) {\n    popularDepartmentCategories {\n      id\n      name\n    }\n    departmentCategories {\n      id\n      name\n      iconUrl\n      description\n    }\n    popularTreatmentCategories {\n      id\n      name\n    }\n    treatmentCategories {\n      id\n      name\n      iconUrl\n      items {\n        id\n        name\n      }\n    }\n  }\n}\n    ";
var useGetDiagnosisCategoriesV2Query = function(variables, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQuery */ .a)([
        "GetDiagnosisCategoriesV2",
        variables
    ], (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables), options);
};
useGetDiagnosisCategoriesV2Query.getKey = function(variables) {
    return [
        "GetDiagnosisCategoriesV2",
        variables
    ];
};
useGetDiagnosisCategoriesV2Query.fetcher = function(variables, options) {
    return (0,_utils_fetcher__WEBPACK_IMPORTED_MODULE_0__/* .gqlFetcher */ .l3)(GetDiagnosisCategoriesV2Document, "GetDiagnosisCategoriesV2", variables, options);
};


/***/ }),

/***/ 60643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ telemedicine_useGetDiagnosisCategories; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/telemedicine/telemedicine.gql.impl.tsx
var telemedicine_gql_impl = __webpack_require__(76122);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(27805);
;// CONCATENATED MODULE: ./src/models/diagnosis/category.ts


var DepartmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function DepartmentCategoryModel(id, name, description, icon) {
        (0,_class_call_check/* default */.Z)(this, DepartmentCategoryModel);
        this.id = id;
        this.name = name;
        this.description = description;
        this.icon = icon;
    }
    var _proto = DepartmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle() {
        switch(this.id){
            case "2":
                return "소아과(소아청소년과) 비대면 진료 | 아이 감기\xb7열\xb7기침 진료 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription() {
        switch(this.id){
            case "2":
                return "아이가 아플 때 빠르게 소아과 진료를 받고 싶다면? 닥터나우에서 의사와 실시간 비대면진료 후 비대면 약 처방받아 보세요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords() {
        switch(this.id){
            case "2":
                return "소아청소년과, 소아과 비대면 진료, 아기 감기, 기침, 열, 소아과약, 처방";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    return DepartmentCategoryModel;
}();
var PopularDepartmentCategoryModel = function PopularDepartmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularDepartmentCategoryModel);
    this.id = id;
    this.name = name;
};
var PopularTreatmentCategoryModel = function PopularTreatmentCategoryModel(id, name) {
    "use strict";
    (0,_class_call_check/* default */.Z)(this, PopularTreatmentCategoryModel);
    this.id = id;
    this.name = name;
};
var TreatmentCategoryModel = /*#__PURE__*/ function() {
    "use strict";
    function TreatmentCategoryModel(id, name, icon, _treatments) {
        (0,_class_call_check/* default */.Z)(this, TreatmentCategoryModel);
        this.id = id;
        this.name = name;
        this.icon = icon;
        this._treatments = _treatments;
    }
    var _proto = TreatmentCategoryModel.prototype;
    _proto.getSeoTitle = function getSeoTitle(treatmentId) {
        switch(treatmentId){
            case "1":
                return "감기\xb7독감 비대면 진료 | 병원 방문 없이 처방받는 닥터나우";
            case "558":
                return "인공눈물 처방 | 안구건조증 비대면 진료 - 닥터나우";
            case "9":
                return "탈모약 비대면 진료 | 피나스테리드\xb7두타스테리드 처방 - 닥터나우";
            case "11":
                return "여드름약 비대면 진료 | 항생제\xb7외용제 빠른 처방 - 닥터나우";
            default:
                return "".concat(this.name, " 비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우");
        }
    };
    _proto.getSeoDescription = function getSeoDescription(treatmentId) {
        switch(treatmentId){
            case "1":
                return "코감기, 인후통, 몸살 증상이 있으신가요? 병원 갈 필요 없이 닥터나우에서 의사와 비대면 진료 후 약 처방받아 보세요.";
            case "558":
                return "눈이 뻑뻑하고 피로하다면? 안과 갈 필요 없이 닥터나우에서 인공눈물, 안구건조증 치료제를 비대면 진료로 빠르게 처방받아보세요.";
            case "9":
                return "피나스테리드, 두타스테리드 등 탈모약을 병원 방문 없이 닥터나우에서 비대면으로 안전하게 처방받으세요.";
            case "11":
                return "여드름으로 고생하고 있다면? 피부과 방문 없이 닥터나우에서 항생제 및 외용제를 비대면 진료로 처방받아보세요.";
            default:
                return "".concat(this.name, "에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면진료로 약 처방까지 받아보세요.");
        }
    };
    _proto.getKeywords = function getKeywords(treatmentId) {
        switch(treatmentId){
            case "1":
                return "감기, 독감, 인후통, 해열제, 비대면 처방";
            case "558":
                return "인공눈물, 안구건조증, 눈 피로, 비대면 진료, 안과 처방, 눈 시림, 눈물약";
            case "9":
                return "탈모약, 피나스테리드, 두타스테리드, 탈모 비대면 처방";
            case "11":
                return "여드름약, 여드름 처방, 피부과 비대면 진료, 항생제";
            default:
                return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
        }
    };
    (0,_create_class/* default */.Z)(TreatmentCategoryModel, [
        {
            key: "treatments",
            get: function get() {
                var _this = this;
                return this._treatments.map(function(treatment) {
                    return {
                        id: treatment.id,
                        name: treatment.name,
                        getSeoTitle: function() {
                            return _this.getSeoTitle(treatment.id);
                        },
                        getSeoDescription: function() {
                            return _this.getSeoDescription(treatment.id);
                        },
                        getKeywords: function() {
                            return _this.getKeywords(treatment.id);
                        }
                    };
                });
            }
        }
    ]);
    return TreatmentCategoryModel;
}();
var DiagnosisCategoryInfoModel = /*#__PURE__*/ function() {
    "use strict";
    function DiagnosisCategoryInfoModel(popularDepartmentCategories, popularTreatmentCategories, departmentCategories, treatmentCategories) {
        (0,_class_call_check/* default */.Z)(this, DiagnosisCategoryInfoModel);
        this.popularDepartmentCategories = popularDepartmentCategories;
        this.popularTreatmentCategories = popularTreatmentCategories;
        this.departmentCategories = departmentCategories;
        this.treatmentCategories = treatmentCategories;
    }
    var _proto = DiagnosisCategoryInfoModel.prototype;
    _proto.findDepartmentCategoryByCategoryId = function findDepartmentCategoryByCategoryId(categoryId) {
        return this.departmentCategories.find(function(category) {
            return category.id === categoryId;
        }) || null;
    };
    _proto.findTreatmentCategoryByTreatmentId = function findTreatmentCategoryByTreatmentId(treatmentId) {
        return this.treatmentCategories.find(function(category) {
            return category.treatments.some(function(treatment) {
                return treatment.id === treatmentId;
            });
        }) || null;
    };
    _proto.findTreatmentByTreatmentId = function findTreatmentByTreatmentId(treatmentId) {
        var foundCategory = this.findTreatmentCategoryByTreatmentId(treatmentId);
        if (!foundCategory) {
            return null;
        }
        return foundCategory.treatments.find(function(treatment) {
            return treatment.id === treatmentId;
        }) || null;
    };
    _proto.getDepartmentCategories = function getDepartmentCategories() {
        return this.departmentCategories;
    };
    return DiagnosisCategoryInfoModel;
}();

// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts





var parseDiagnosisCategories = function(data) {
    var categoriesInfo = data.getDiagnosisCategoriesV2;
    return new DiagnosisCategoryInfoModel(categoriesInfo.popularDepartmentCategories.map(function(departmentCategory) {
        return new PopularDepartmentCategoryModel(departmentCategory.id, departmentCategory.name);
    }), categoriesInfo.popularTreatmentCategories.map(function(treatmentCategory) {
        return new PopularTreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name);
    }), categoriesInfo.departmentCategories.map(function(departmentCategory) {
        var _description;
        return new DepartmentCategoryModel(departmentCategory.id, departmentCategory.name, (_description = departmentCategory.description) !== null && _description !== void 0 ? _description : "", departmentCategory.iconUrl);
    }), categoriesInfo.treatmentCategories.map(function(treatmentCategory) {
        return new TreatmentCategoryModel(treatmentCategory.id, treatmentCategory.name, treatmentCategory.iconUrl, treatmentCategory.items.map(function(treatment) {
            return {
                id: treatment.id,
                name: treatment.name
            };
        }));
    }));
};
var useGetDiagnosisCategories = function() {
    var ref = (0,telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query */.lE)({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    }, {
        select: parseDiagnosisCategories
    }), tmp = ref.data, categoriesInfo = tmp === void 0 ? new DiagnosisCategoryInfoModel([], [], [], []) : tmp;
    return {
        categoriesInfo: categoriesInfo
    };
};
/* harmony default export */ var telemedicine_useGetDiagnosisCategories = (useGetDiagnosisCategories);
useGetDiagnosisCategories.getKey = function() {
    return telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.getKey */.lE.getKey({
        contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
    });
};
useGetDiagnosisCategories.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(useGetDiagnosisCategories.getKey(), telemedicine_gql_impl/* useGetDiagnosisCategoriesV2Query.fetcher */.lE.fetcher({
                            contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 87968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ doctors; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./src/components/atom/CustomBreadCrumbs.tsx
var CustomBreadCrumbs = __webpack_require__(12429);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 4 modules
var PaginationComponent = __webpack_require__(45185);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/doctor/components/NonF2fDoctorItem.tsx




var NonF2fDoctorItem = function(props) {
    var doctor = props.doctor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative flex items-center justify-between pr-[16px] pl-[24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col gap-[12px] pt-[20px] pb-[24px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "typography-ui-13r text-gray-400",
                                children: doctor.hospitalName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-[8px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "typography-ui-19sb text-gray-900",
                                        children: doctor.doctorNameFullText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "star",
                                                color: theme/* default.color.yellow500 */.Z.color.yellow500,
                                                size: 16,
                                                filled: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "typography-ui-13m text-gray-700",
                                                children: doctor.review.reviewAverageText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "typography-ui-13r text-gray-400",
                                                children: [
                                                    "(",
                                                    doctor.review.reviewCountText,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            doctor.bookingInfo.isBookingAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center gap-[5px]",
                                children: doctor.bookingInfo.closestSchedule && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (0,style.cn)([
                                                "typography-ui-13m",
                                                {
                                                    "text-green-700": doctor.bookingInfo.closestSchedule.isTodayBookable,
                                                    "text-primary-600": !doctor.bookingInfo.closestSchedule.isTodayBookable
                                                }, 
                                            ]),
                                            children: doctor.bookingInfo.closestSchedule.scheduleTypeText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-[10px] w-[1px] bg-gray-50"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "typography-ui-13r text-gray-400",
                                            children: doctor.bookingInfo.closestSchedule.schedule
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "typography-ui-13m text-gray-700",
                                children: "예약 마감"
                            })
                        ]
                    }),
                    (doctor.professionalDepartmentName || doctor.readyForVideoCall) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-[4px]",
                        children: [
                            doctor.professionalDepartmentName && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                className: "ty typography-ui-12m flex h-[20px] items-center rounded bg-gray-30 px-[4px] text-gray-500",
                                children: [
                                    doctor.professionalDepartmentName,
                                    " 전문의"
                                ]
                            }),
                            doctor.readyForVideoCall && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "ty typography-ui-12m flex h-[20px] items-center rounded bg-gray-30 px-[4px] text-gray-500",
                                children: "영상진료"
                            })
                        ]
                    }),
                    doctor.medicinePricing && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "typography-ui-20sb text-gray-900",
                        children: [
                            doctor.medicinePricing.medicinePriceDisplayPrice,
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative pb-[8px]",
                children: doctor.profileUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "aspect-square h-[120px] w-[120px]",
                            src: doctor.profileUrl,
                            alt: "".concat(doctor.doctorName, " 의사 사진")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,style.cn)([
                                "absolute right-0 bottom-[8px] left-0 h-[24px] w-[120px]",
                                {
                                    "bg-gradient-to-t from-white to-transparent": doctor.profileUrl
                                }, 
                            ])
                        })
                    ]
                })
            }),
            !doctor.bookingInfo.isBookingAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 right-0 bottom-0 left-0 bg-white opacity-50"
            })
        ]
    });
};
/* harmony default export */ var components_NonF2fDoctorItem = (NonF2fDoctorItem);

// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/templates/telemedicine/doctor/TelemedicineDoctorsTemplate.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n       display: flex;\n       gap: 12px;\n       min-height: 60px;\n       padding: 0 20px 0 24px;\n       align-items: ",
        ";\n       flex-direction: ",
        ";\n     "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var TelemedicineDoctorsTemplate = function(param) {
    var viewModel = param.viewModel, client = param.client;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            !client.isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBreadCrumbs/* default */.Z, {
                    breadCrumbs: viewModel.breadCrumbs,
                    visible: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.Content */.Z.Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pb-[80px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: "typography-ui-22sb text-gray-900",
                                    children: [
                                        viewModel.category.name,
                                        " 비대면 진료"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: common/* ROUTES.TELEMEDICINE.CATEGORIES.path */.Z6.TELEMEDICINE.CATEGORIES.path,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "flex items-center gap-[4px] rounded-[8px] bg-gray-30 px-[16px] py-[13px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "typography-ui-17m text-gray-700",
                                                children: "증상/과목 선택"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                                                name: "keyboard_arrow_down",
                                                color: theme/* default.color.gray700 */.Z.color.gray700,
                                                size: 20,
                                                filled: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            className: "flex flex-col",
                            children: viewModel.nonF2fDoctors.map(function(doctor) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: common/* ROUTES.DOCTOR.DETAIL.path */.Z6.DOCTOR.DETAIL.path + "/".concat(doctor.doctorPublicId, "?type=").concat(viewModel.categoryType, "&categoryId=").concat(viewModel.categoryId),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NonF2fDoctorItem, {
                                                    doctor: doctor
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "h-[1px] w-full bg-gray-30"
                                                })
                                            ]
                                        })
                                    })
                                }, "doctor-list-".concat(doctor.doctorPublicId));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                            baseUrl: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path,
                            queries: viewModel.queries,
                            currentPage: viewModel.currentPage,
                            perPage: 5,
                            totalPage: viewModel.totalPage
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var doctor_TelemedicineDoctorsTemplate = (TelemedicineDoctorsTemplate);
var HeaderSection = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-f8d452ad-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.client.isMobile ? "flex-start" : "center", theme.client.isMobile ? "column" : "row");
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ./src/hooks/telemedicine/useGetDiagnosisCategories.ts + 1 modules
var useGetDiagnosisCategories = __webpack_require__(60643);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ./src/hooks/telemedicine/telemedicine.gql.impl.tsx
var telemedicine_gql_impl = __webpack_require__(76122);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_class.mjs
var src_create_class = __webpack_require__(27805);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/models/doctor/telemedicine.ts



var EBookingAvailability;
(function(EBookingAvailability) {
    EBookingAvailability["NotBookable"] = "NOT_BOOKABLE";
    EBookingAvailability["TodayBookable"] = "TODAY_BOOKABLE";
    EBookingAvailability["TomorrowBookable"] = "TOMORROW_BOOKABLE";
    EBookingAvailability["UpcomingBookable"] = "UPCOMING_BOOKABLE";
    EBookingAvailability["Unknown"] = "UNKNOWN";
})(EBookingAvailability || (EBookingAvailability = {}));
var EBookingScheduleType;
(function(EBookingScheduleType) {
    EBookingScheduleType["Today"] = "TODAY";
    EBookingScheduleType["Tomorrow"] = "TOMORROW";
})(EBookingScheduleType || (EBookingScheduleType = {}));
var NonF2fDoctorReviewInfo = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fDoctorReviewInfo(averageRating, count) {
        (0,src_class_call_check/* default */.Z)(this, NonF2fDoctorReviewInfo);
        this.averageRating = averageRating;
        this.count = count;
        this.formatReviewCount = function(count) {
            if (count >= 2000) return "2000+";
            if (count >= 1500) return "1500+";
            if (count >= 1000) return "1000+";
            if (count >= 500) return "500+";
            if (count >= 300) return "300+";
            if (count >= 200) return "200+";
            if (count >= 100) return "100+";
            if (count >= 50) return "50+";
            if (count >= 20) return "20+";
            if (count >= 10) return "10+";
            return String(count);
        };
    }
    (0,src_create_class/* default */.Z)(NonF2fDoctorReviewInfo, [
        {
            key: "reviewCountText",
            get: function get() {
                return "".concat(this.formatReviewCount(this.count));
            }
        },
        {
            key: "reviewAverageText",
            get: function get() {
                return "".concat(this.averageRating.toFixed(1));
            }
        }
    ]);
    return NonF2fDoctorReviewInfo;
}();
var NonF2fBookingSchedule = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fBookingSchedule(isBookable, schedule, scheduleType) {
        (0,src_class_call_check/* default */.Z)(this, NonF2fBookingSchedule);
        this.isBookable = isBookable;
        this.schedule = schedule;
        this.scheduleType = scheduleType;
    }
    (0,src_create_class/* default */.Z)(NonF2fBookingSchedule, [
        {
            key: "isTodayBookable",
            get: function get() {
                return this.scheduleType === EBookingScheduleType.Today;
            }
        },
        {
            key: "scheduleTypeText",
            get: function get() {
                if (this.scheduleType === EBookingScheduleType.Today) {
                    return "오늘 예약";
                }
                return "내일 예약";
            }
        }
    ]);
    return NonF2fBookingSchedule;
}();
var NonF2fBookingInfo = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fBookingInfo(bookingAvailability, schedules) {
        (0,src_class_call_check/* default */.Z)(this, NonF2fBookingInfo);
        this.bookingAvailability = bookingAvailability;
        this.schedules = schedules;
    }
    (0,src_create_class/* default */.Z)(NonF2fBookingInfo, [
        {
            key: "isBookingAvailable",
            get: function get() {
                return this.bookingAvailability !== EBookingAvailability.NotBookable;
            }
        },
        {
            key: "closestSchedule",
            get: function get() {
                return this.schedules.find(function(schedule) {
                    return schedule.isBookable;
                }) || null;
            }
        }
    ]);
    return NonF2fBookingInfo;
}();
var NonF2fDoctorMedicinePricing = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function NonF2fDoctorMedicinePricing(treatmentMedicineName, doctorTreatmentMedicineUnitPricingId, originalPrice, priceOnUsingPoint, unit) {
        _class_call_check(this, NonF2fDoctorMedicinePricing);
        this.treatmentMedicineName = treatmentMedicineName;
        this.doctorTreatmentMedicineUnitPricingId = doctorTreatmentMedicineUnitPricingId;
        this.originalPrice = originalPrice;
        this.priceOnUsingPoint = priceOnUsingPoint;
        this.unit = unit;
    }
    _create_class(NonF2fDoctorMedicinePricing, [
        {
            key: "medicinePriceDisplayPrice",
            get: function get() {
                return formatPriceComma(this.priceOnUsingPoint);
            }
        }
    ]);
    return NonF2fDoctorMedicinePricing;
}()));
var NonF2fDoctor = /*#__PURE__*/ function() {
    "use strict";
    function NonF2fDoctor(hospitalName, doctorPublicId, doctorName, medicineType, _profileUrl, readyForVideoCall, professionalDepartmentName, review, bookingInfo, medicinePricing) {
        (0,src_class_call_check/* default */.Z)(this, NonF2fDoctor);
        this.hospitalName = hospitalName;
        this.doctorPublicId = doctorPublicId;
        this.doctorName = doctorName;
        this.medicineType = medicineType;
        this._profileUrl = _profileUrl;
        this.readyForVideoCall = readyForVideoCall;
        this.professionalDepartmentName = professionalDepartmentName;
        this.review = review;
        this.bookingInfo = bookingInfo;
        this.medicinePricing = medicinePricing;
    }
    (0,src_create_class/* default */.Z)(NonF2fDoctor, [
        {
            key: "medicineTypeText",
            get: function get() {
                if (this.medicineType === "oriental_doctor") {
                    return "한의사";
                }
                return "의사";
            }
        },
        {
            key: "doctorNameFullText",
            get: function get() {
                return "".concat(this.doctorName, " ").concat(this.medicineTypeText);
            }
        },
        {
            key: "profileUrl",
            get: function get() {
                if (!this._profileUrl || this._profileUrl.includes("null")) {
                    return null;
                }
                return this._profileUrl;
            }
        }
    ]);
    return NonF2fDoctor;
}();

// EXTERNAL MODULE: ./src/services/doctor/DiagnosisCategoryService.ts
var DiagnosisCategoryService = __webpack_require__(33310);
// EXTERNAL MODULE: ./src/shared/utils/typeGuard.ts
var typeGuard = __webpack_require__(95214);
// EXTERNAL MODULE: ./src/types/bff/gql-schema.ts
var gql_schema = __webpack_require__(72271);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useSearchDoctorsByUser.ts








var parseCategoryType = function(categoryType) {
    switch(categoryType){
        case DiagnosisCategoryService/* ECategoryType.Department */.qm.Department:
            return gql_schema/* MedicalCategoryType.Department */.WkB.Department;
        case DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment:
            return gql_schema/* MedicalCategoryType.Treatment */.WkB.Treatment;
    }
};
var parseBookingAvailability = function(bookingAvailability) {
    try {
        switch(bookingAvailability){
            case gql_schema/* BookingAvailability.NotBookable */.hlw.NotBookable:
                return EBookingAvailability.NotBookable;
            case gql_schema/* BookingAvailability.TodayBookable */.hlw.TodayBookable:
                return EBookingAvailability.TodayBookable;
            case gql_schema/* BookingAvailability.TomorrowBookable */.hlw.TomorrowBookable:
                return EBookingAvailability.TomorrowBookable;
            case gql_schema/* BookingAvailability.UpcomingBookable */.hlw.UpcomingBookable:
                return EBookingAvailability.UpcomingBookable;
            default:
                (0,typeGuard/* exhaustiveGuard */.Y)(bookingAvailability);
        }
    } catch (e) {
        return EBookingAvailability.Unknown;
    }
};
var parseDoctorByUser = function(data) {
    return {
        totalCount: data.searchDoctorsByUser.totalCount,
        doctors: data.searchDoctorsByUser.items.map(function(doctor) {
            var ref;
            var _profileUrl, ref1;
            return new NonF2fDoctor(doctor.hospitalName, doctor.publicId, doctor.name, doctor.medicineType, (_profileUrl = doctor.profileUrl) !== null && _profileUrl !== void 0 ? _profileUrl : null, doctor.readyForVideoCall, (ref1 = (ref = doctor.professionalDepartment) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : null, new NonF2fDoctorReviewInfo(doctor.reviewAverageRating, doctor.reviewCount), new NonF2fBookingInfo(parseBookingAvailability(doctor.bookingInfo.bookingAvailability), [
                new NonF2fBookingSchedule(doctor.bookingInfo.todayBookable, doctor.bookingInfo.todaySchedule, EBookingScheduleType.Today),
                new NonF2fBookingSchedule(doctor.bookingInfo.tomorrowBookable, doctor.bookingInfo.tomorrowSchedule, EBookingScheduleType.Tomorrow), 
            ]), null);
        })
    };
};
var SEARCH_DOCTORS_LIMIT = 10;
var DEFAULT_OPTIONS = {
    limit: SEARCH_DOCTORS_LIMIT,
    sortType: gql_schema/* DoctorSortType.Default */.tt_.Default,
    contactType: gql_schema/* DiagnosisContactType.NonF2F */.qnl.NonF2F,
    priceType: gql_schema/* DiagnosisPriceType.DiagnosisOnly */.dqE.DiagnosisOnly
};
var useSearchDoctorsByUser = function(categoryType, categoryId, page) {
    var ref = (0,telemedicine_gql_impl/* useSearchDoctorsByUserQuery */.ze)({
        request: (0,_object_spread/* default */.Z)({
            medicalCategory: {
                category: parseCategoryType(categoryType),
                id: categoryId
            },
            page: page
        }, DEFAULT_OPTIONS)
    }, {
        enabled: !!categoryId && !!categoryType && !!page,
        select: parseDoctorByUser
    }), _data = ref.data, data = _data === void 0 ? {
        doctors: [],
        totalCount: 0
    } : _data;
    return {
        nonF2fDoctors: data.doctors,
        totalPage: Math.floor(data.totalCount / SEARCH_DOCTORS_LIMIT) + (data.totalCount % SEARCH_DOCTORS_LIMIT > 0 ? 1 : 0)
    };
};
/* harmony default export */ var telemedicine_useSearchDoctorsByUser = (useSearchDoctorsByUser);
useSearchDoctorsByUser.getKey = function(categoryType, categoryId, page) {
    return telemedicine_gql_impl/* useSearchDoctorsByUserQuery.getKey */.ze.getKey({
        request: (0,_object_spread/* default */.Z)({
            medicalCategory: {
                category: parseCategoryType(categoryType),
                id: categoryId
            },
            page: page
        }, DEFAULT_OPTIONS)
    });
};
useSearchDoctorsByUser.prefetchQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(queryClient, categoryType, categoryId, page) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.prefetchQuery(useSearchDoctorsByUser.getKey(categoryType, categoryId, page), telemedicine_gql_impl/* useSearchDoctorsByUserQuery.fetcher */.ze.fetcher({
                            request: (0,_object_spread/* default */.Z)({
                                medicalCategory: {
                                    category: parseCategoryType(categoryType),
                                    id: categoryId
                                },
                                page: page
                            }, DEFAULT_OPTIONS)
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function(queryClient, categoryType, categoryId, page) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/hooks/telemedicine/useTelemedicineDoctorsViewModel.ts










var defaultSeoCategory = {
    id: "",
    name: "",
    getSeoTitle: function() {
        return "비대면 진료 | 진료과\xb7질환별 원격진료 - 닥터나우";
    },
    getSeoDescription: function() {
        return "내 증상에 맞는 의사를 빠르게 찾고, 병원 방문 없이 비대면 진료로 약 처방까지 받아보세요.";
    },
    getKeywords: function() {
        return "비대면진료, 원격진료, 온라인진료, 비대면처방, 약처방, 약배송, 약배달, 진료비";
    }
};
var useTelemedicineDoctorsViewModel = function() {
    var router = (0,next_router.useRouter)();
    var queries = router.query;
    var type = queries.type, id = queries.id, _page = queries.page, page = _page === void 0 ? "1" : _page;
    var currentPage = Number(page);
    var breadCrumbs = [
        {
            url: common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path + (0,url/* addQueryString */.sC)(queries),
            label: "비대면 진료",
            logName: "telemedicine_doctors"
        }, 
    ];
    var categoriesInfo = (0,useGetDiagnosisCategories/* default */.Z)().categoriesInfo;
    var ref = telemedicine_useSearchDoctorsByUser(type, id, currentPage), nonF2fDoctors = ref.nonF2fDoctors, totalPage = ref.totalPage;
    var seoCategory = (0,react.useMemo)(function() {
        if (type === DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment) {
            var ref;
            return (ref = categoriesInfo.findTreatmentByTreatmentId(id)) !== null && ref !== void 0 ? ref : defaultSeoCategory;
        }
        var ref1;
        return (ref1 = categoriesInfo.findDepartmentCategoryByCategoryId(id)) !== null && ref1 !== void 0 ? ref1 : defaultSeoCategory;
    }, [
        categoriesInfo,
        type,
        id
    ]);
    (0,react.useEffect)(function() {
        if (!seoCategory) {
            return;
        }
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, (0,_object_spread/* default */.Z)({}, type === DiagnosisCategoryService/* ECategoryType.Treatment */.qm.Treatment ? {
            symptom: seoCategory.name
        } : {
            subject: seoCategory.name
        }));
    }, [
        seoCategory
    ]);
    return {
        currentPage: currentPage,
        queries: queries,
        category: seoCategory,
        categoriesInfo: categoriesInfo,
        nonF2fDoctors: nonF2fDoctors,
        breadCrumbs: breadCrumbs,
        totalPage: totalPage,
        categoryType: type,
        categoryId: id
    };
};
/* harmony default export */ var telemedicine_useTelemedicineDoctorsViewModel = (useTelemedicineDoctorsViewModel);

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/pages/telemedicine/doctors.tsx
// PageDescription: 비대면진료 의사 목록 페이지






var TelemedicineDoctorsPage = function(param) {
    var client = param.client;
    var viewModel = telemedicine_useTelemedicineDoctorsViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: viewModel.category.getSeoTitle(),
                description: viewModel.category.getSeoDescription(),
                additionalMetaTags: [
                    {
                        name: "keywords",
                        content: viewModel.category.getKeywords()
                    }, 
                ],
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path).concat((0,url/* addQueryString */.sC)(viewModel.queries))
                },
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.TELEMEDICINE.DOCTORS.path */.Z6.TELEMEDICINE.DOCTORS.path).concat((0,url/* addQueryString */.sC)(viewModel.queries))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(doctor_TelemedicineDoctorsTemplate, {
                viewModel: viewModel,
                client: client
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var doctors = (TelemedicineDoctorsPage);


/***/ }),

/***/ 95214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ exhaustiveGuard; }
/* harmony export */ });
function exhaustiveGuard(_value) {
    throw new Error("ERROR! Reached forbidden guard function with unexpected value: ".concat(JSON.stringify(_value)));
}


/***/ }),

/***/ 37072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ HeaderType; }
/* harmony export */ });
var HeaderType;
(function(HeaderType) {
    HeaderType["WithMobileHeader"] = "withMobileHeader";
})(HeaderType || (HeaderType = {}));


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1498,8711,9774,2888,179], function() { return __webpack_exec__(19739); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);